import {LogoBrand} from './LogoBrand.tsx';
import {ChipTone, type BankCardSkin} from './types.ts';

function Face() {
    return (
        <>
            <div className="absolute inset-0 bg-[radial-gradient(120%_140%_at_18%_12%,#2C4A37_0%,#22392B_45%,#1A2C21_100%)]" />
            <div className="absolute inset-0 bg-[repeating-linear-gradient(125deg,rgba(255,255,255,0.018)_0_2px,rgba(0,0,0,0)_2px_5px)]" />
        </>
    );
}

export const bunqSkin: BankCardSkin = {
    Face,
    Brand: LogoBrand,
    chipTone: ChipTone.Sage,
    hasMastercard: true,
    surfaceTone: 'dark',
    contentColor: '#FFFFFF',
    labelColor: '#B9CCBF',
    contactlessColor: '#CFE6D6',
    mastercardWordColor: '#EAF3EC',
};
